import React, { createContext, useContext } from 'react';
import { Layout } from '../../../components/layout/Layout';

const SupportShellEmbeddedContext = createContext(false);

/** Set when support routes mount under StudentSectionLayout (student role only). */
export function SupportShellEmbeddedProvider({ children }: { children: React.ReactNode }) {
  return (
    <SupportShellEmbeddedContext.Provider value={true}>{children}</SupportShellEmbeddedContext.Provider>
  );
}

export function useSupportShellEmbedded(): boolean {
  return useContext(SupportShellEmbeddedContext);
}

type SupportPageShellProps = {
  children: React.ReactNode;
};

/**
 * Support page chrome — renders Layout unless already nested in a persistent role shell
 * (e.g. StudentSectionLayout). Teacher/parent/admin routes omit the provider and keep Layout.
 */
export function SupportPageShell({ children }: SupportPageShellProps) {
  const embedded = useSupportShellEmbedded();
  if (embedded) {
    return <>{children}</>;
  }
  return <Layout>{children}</Layout>;
}
